import { plainToClass } from "class-transformer";
import { JobFunctionEntity, ContactListingFormObject } from "../contacts.objects";
import { SiteEntity } from "../../sites/sites.objects";
import { AuditHistoryDialog } from '../../audit/scripts/audit-history.dialog';

export class ContactDialog {
    contact: ContactListingFormObject;
    sites: SiteEntity[];
    prefixes: any[];
    jobFunctions: JobFunctionEntity[];
    studySiteMap: Map<string, string[]> = new Map();

    successCallback: (response: any) => void;
    auditHistoryDialog: AuditHistoryDialog | null = null;

    constructor(allSitesJson: any, allJobFunctions, auditHistoryDialog?: AuditHistoryDialog) {
        customElements.define('site-section', SiteSection);
        customElements.define('study-section', StudySection);
        this.sites = plainToClass(SiteEntity, <SiteEntity[]>allSitesJson);
        this.sites.forEach((site: SiteEntity) => { site.initialize(); });
        this.jobFunctions = plainToClass(JobFunctionEntity, <JobFunctionEntity[]>allJobFunctions);
        this.prefixes = [
            { Id: 'Mr.', Name: 'Mr.' },
            { Id: 'Ms.', Name: 'Ms.' },
            { Id: 'Mrs.', Name: 'Mrs.' },
            { Id: 'Dr.', Name: 'Dr.' }
        ];

        if (auditHistoryDialog) this.auditHistoryDialog = auditHistoryDialog;
        this.setUpDialog();
    }



    toggleMiNumberField(siteSectionId: string, studySectionId: string): void{


        const jobFunctionSelect = document.getElementById(`jobFunction-${siteSectionId}-${studySectionId}`) as HTMLSelectElement;

        const studyColumn = document.getElementById(`studyColumn-${siteSectionId}-${studySectionId}`) as HTMLElement;

        const roleColumn = document.getElementById(`roleColumn-${siteSectionId}-${studySectionId}`) as HTMLElement;

        const checkboxColumn = document.getElementById(`checkboxColumn-${siteSectionId}-${studySectionId}`) as HTMLElement;

        const jobFunctionContainer = document.getElementById(`jobFunctionContainer-${siteSectionId}-${studySectionId}`) as HTMLElement;

        const miNumberColumn = document.getElementById(`miNumberColumn-${siteSectionId}-${studySectionId}`) as HTMLElement;




        const selectedText = jobFunctionSelect.options[jobFunctionSelect.selectedIndex]?.text?.trim();

        if (selectedText === "PI") {

            studyColumn.classList.remove("col-4");
            studyColumn.classList.add("col-3");


            checkboxColumn.classList.remove("col-2");
            checkboxColumn.classList.add("col-3");

            
            jobFunctionContainer.classList.remove("col-12");
            jobFunctionContainer.classList.add("col-6");

            miNumberColumn.style.display = "";
        }else{


            studyColumn.classList.remove("col-3");
            studyColumn.classList.add("col-4");

            checkboxColumn.classList.remove("col-3");
            checkboxColumn.classList.add("col-2");

           
            jobFunctionContainer.classList.remove("col-6");
            jobFunctionContainer.classList.add("col-12");

            miNumberColumn.style.display = "none";
        }
    }

    populateModal(c) {
        this.contact = plainToClass(ContactListingFormObject, <ContactListingFormObject>c);
        this.contact.initialize();

        this.clearContactModal();

        const title = document.getElementById('newContactDialogLabel');
        title.innerHTML = 'Edit Contact';
        const firstNameInput = document.getElementById('firstName') as HTMLInputElement;
        const lastNameInput = document.getElementById('lastName') as HTMLInputElement;
        const emailInput = document.getElementById('email') as HTMLInputElement;
        const phoneInput = document.getElementById('phoneNumber') as HTMLInputElement;
        const prefixInput = document.getElementById('prefix') as HTMLSelectElement;
        const titleInput = document.getElementById('title') as HTMLInputElement;
        const notesInput = document.getElementById('notes') as HTMLInputElement;
        const idInput = document.getElementById('id') as HTMLInputElement;
        firstNameInput.value = this.contact.FirstName;
        lastNameInput.value = this.contact.LastName;
        emailInput.value = this.contact.Email;
        phoneInput.value = this.contact.PhoneNumber;
        const prefix = this.prefixes.find(prefix => prefix.Name == this.contact.Prefix);
        prefixInput.value = prefix && prefix.Id !== -1 ? prefix.Id.toString() : '';
        titleInput.value = this.contact.Title;
        notesInput.value = this.contact.Notes;
        idInput.value = String(this.contact.Id);


        this.contact.Sites.forEach((site) => {
            const siteSectionId = this.addSiteSection();
            const siteId = site.SiteId;
            const siteSelect = document.getElementById('site-' + siteSectionId) as HTMLSelectElement;
            siteSelect.value = siteId.toString();
            site.StudyIds.forEach((sid, idx) => {
                this.addStudySection(siteSectionId);
            });
            for (let i = 0; i < site.StudyIds.length; i++) {
                const studySectionId = this.studySiteMap.get(siteSectionId)[i];
                const studySelect = document.getElementById('study-' + siteSectionId + '-' + studySectionId) as HTMLSelectElement;
                studySelect.value = site.StudyIds[i].toString();
                const jobFunctionSelect = document.getElementById('jobFunction-' + siteSectionId + '-' + studySectionId) as HTMLSelectElement;
                jobFunctionSelect.value = site.JobFunctionIds[i] != null ? site.JobFunctionIds[i].toString() : '-1';
                const miNumberInput = document.getElementById('miNumber-' + siteSectionId + '-' + studySectionId) as HTMLInputElement;
                miNumberInput.value = site.MiNumbers[i] ?? '';
                this.toggleMiNumberField(siteSectionId, studySectionId);
                const isPrimaryContactInput = document.getElementById('isPrimaryContact-' + siteSectionId + '-' + studySectionId) as HTMLInputElement;
                isPrimaryContactInput.checked = site.IsPrimaryContacts[i];
                const isReceivingAllCommunicationsInput = document.getElementById('isReceivingAllCommunications-' + siteSectionId + '-' + studySectionId) as HTMLInputElement;
                isReceivingAllCommunicationsInput.checked = site.IsReceivingAllCommunications[i];

                const contactSiteStudyId = site.ContactSiteStudyIds?.[i];
                const miNumberContainer = document.getElementById(`miNumberContainer-${siteSectionId}-${studySectionId}`);

                const auditIcon = miNumberContainer?.querySelector('.ctms-icon-history[data-audit-field="MiNumber"]');
                if (auditIcon) {
                    auditIcon.setAttribute('data-entity-id', String(contactSiteStudyId ?? ''));
                }
            }
        });

    }

    populateDropdown(id: string, options: any[], defaultValue: string = '-1'): void {
        const select = document.getElementById(id);
        if (select?.hasChildNodes()) {
            while (select.firstChild) {
                select.removeChild(select.firstChild);
            }
        }

        const defaultOption = document.createElement('option');
        defaultOption.value = defaultValue;
        defaultOption.text = 'Select an option';
        select?.appendChild(defaultOption);

        for (let i = 0; i < options.length; i++) {


            const option = document.createElement('option');
            option.value = options[i].Id.toString();

            if (id.includes('site')){
                option.text = options[i].SiteName;
            }else{
                option.text = options[i].Name;
            }
            select?.appendChild(option);
        }
    }
        
    populateStudy(val: string, siteSectionId: string, targetStudySectionId?: string) {
        if (val == '-1') return;

        const studySections = targetStudySectionId
            ? [targetStudySectionId]
            : this.studySiteMap.get(siteSectionId);
        if (!studySections) return;
        studySections.forEach((studySectionId) => {
            const defaultOption = document.createElement('option');
            defaultOption.value = '-1';
            defaultOption.text = 'Select an option';
            const studyId = 'study-' + siteSectionId + '-' + studySectionId;
            const studySelect = document.getElementById(studyId);
            if (studySelect) {
                studySelect?.removeAttribute('disabled');

                if (studySelect?.hasChildNodes()) {
                    while (studySelect.firstChild) {
                        studySelect.removeChild(studySelect.firstChild);
                    }
                }
                studySelect?.appendChild(defaultOption);

                const siteId = Number(val);
                const site = this.sites.find(s => s.Id == siteId);
                const studies = site.CTMSStudies;
                for (let i = 0; i < studies.length; i++) {
                    const option = document.createElement('option');
                    option.value = studies[i].Id.toString();
                    option.text = studies[i].Name;
                    studySelect?.appendChild(option);
                }
            }
        });
    }

    clearContactModal(): void {
        const dialog = $('#newContactDialog');
        this.studySiteMap = new Map();
        const title = document.getElementById('newContactDialogLabel');
        title.innerHTML = 'New Contact';
        dialog.removeClass('ctms-invalid-form');
        dialog.find('#validation-errors').addClass('d-none');
        dialog.find('#validation-error').addClass('d-none');
        dialog.find('#validation-error-assignments').addClass('d-none');
        dialog.find('#validation-error-assignments-icon').addClass('d-none');
        const firstNameInput = document.getElementById('firstName') as HTMLInputElement;
        const lastNameInput = document.getElementById('lastName') as HTMLInputElement;
        const emailInput = document.getElementById('email') as HTMLInputElement;
        const phoneInput = document.getElementById('phoneNumber') as HTMLInputElement;
        const prefixInput = document.getElementById('prefix') as HTMLSelectElement;
        const siteContainer = document.getElementById('site-container');
        siteContainer.innerHTML = '';
        const titleInput = document.getElementById('title') as HTMLInputElement;
        const notesInput = document.getElementById('notes') as HTMLInputElement;
        const idInput = document.getElementById('id') as HTMLInputElement;
        firstNameInput.value = '';
        lastNameInput.value = '';
        emailInput.value = '';
        phoneInput.value = '';
        titleInput.value = '';
        notesInput.value = '';
        idInput.value = '-1';

        this.populateDropdown('jobFunction', this.jobFunctions);
        this.populateDropdown('site', this.sites);
        this.populateDropdown('prefix', this.prefixes, '');

        prefixInput.value = '';
    }


    setUpDialog(): void {
        $('#newContactDialog .ctms-button-save').on('click', () => {
            this.saveForm();
        });
        $('#add-site-button').on('click', () => {
            this.addSiteSection();
        });
        $('#newContactDialog').on('hidden.bs.modal', () => {
            this.clearContactModal();
        });
        if (this.auditHistoryDialog) {
            $('#newContactDialog').on('click', '.ctms-icon-history[data-audit-field]', (evt) => {
                const icon = $(evt.currentTarget);
                const entityType = (icon.data('entity-type') as string) || 'Contact';
                const fieldName = icon.data('audit-field') as string;
                const fieldLabel = icon.data('audit-label') as string;
                const entityId = entityType === 'ContactSiteStudy'
                    ? Number(icon.attr('data-entity-id'))
                    : Number($(document.getElementById('id')).val());
                this.auditHistoryDialog.show(entityType, entityId, fieldName, fieldLabel);
            });
        }
        const dialog = $('#newContactDialog');

        $('#firstName, #lastName, #email, #phoneNumber').on('input', () => {
            dialog.find('#validation-error').addClass('d-none');
        });

        $('#site-container').on('change', 'select[id^="site-"]', () => {
            const dialog = $('#newContactDialog');

            dialog.find('#validation-error-assignments').addClass('d-none');
            dialog.find('#validation-error-assignments-icon').addClass('d-none');

            if (
                dialog.find('#validation-error').hasClass('d-none') &&
                dialog.find('#validation-error-assignments').hasClass('d-none')
            ) {
                dialog.find('#validation-errors').addClass('d-none');
            }
        });
        this.addSiteSection();
    }

    addSiteSection(): string {
        const siteContainer = document.getElementById('site-container');
        const siteSection = document.createElement('site-section') as SiteSection;
        //generate unique random ID so deletion doesn't mess up indexing
        const siteSectionId = crypto.randomUUID();
        siteSection.siteSectionId = siteSectionId;
        siteSection.initialize();
        siteContainer?.appendChild(siteSection);
        this.setupSiteRemoveButton(siteSectionId);
        this.populateDropdown('site-' + siteSectionId, this.sites)
        $('#site-' + siteSectionId).on('change', (e) => {
            const selectedValue = (e.target as HTMLSelectElement).value;
            this.populateStudy(selectedValue, siteSectionId);
        });
        $('#add-study-' + siteSectionId).on('click', () => {
            this.addStudySection(siteSectionId);
        });
        return siteSectionId;
    }

    setupSiteRemoveButton(siteSectionId: string): void {
        $('#remove-button-' + siteSectionId + '-site').on('click', () => {
            this.removeSiteSection(siteSectionId);
        });
    }

    removeSiteSection(siteSectionId: string): void {
        const sectionToRemove = document.getElementById('site-section-' + siteSectionId);
        sectionToRemove?.remove();
        this.studySiteMap.delete(siteSectionId);
    }

    addStudySection(siteSectionId: string): void {
        const studyContainer = document.getElementById('study-container-' + siteSectionId);
        const studySectionId = crypto.randomUUID();
        const studySection = document.createElement('study-section') as StudySection;
        studySection.siteSectionId = siteSectionId;
        studySection.studySectionId = studySectionId;
        studySection.initialize();
        studyContainer?.appendChild(studySection);
        this.setupStudyRemoveButton(siteSectionId, studySectionId);
        this.populateDropdown('jobFunction-' + siteSectionId + '-' + studySectionId, this.jobFunctions);
        $('#jobFunction-' + siteSectionId + '-' + studySectionId).on('change', () => {
            this.toggleMiNumberField(siteSectionId, studySectionId);
        });

        this.toggleMiNumberField(siteSectionId, studySectionId);

        if (!this.studySiteMap.has(siteSectionId)) {
            this.studySiteMap.set(siteSectionId, []);
        }
        this.studySiteMap.get(siteSectionId).push(studySectionId);
        this.populateStudy($('#site-' + siteSectionId).val() as string, siteSectionId, studySectionId);

        $('#study-' + siteSectionId + '-' + studySectionId + ', #jobFunction-' + siteSectionId + '-' + studySectionId).on('change', () => {
            this.updateValidationVisibility();
    
        });
    }

    setupStudyRemoveButton(siteSectionId: string, studySectionId: string): void {
        $('#study-remove-button-' + siteSectionId + '-' + studySectionId).on('click', () => {
            this.removeStudySection(siteSectionId, studySectionId);
        });
    }

    removeStudySection(siteSectionId: string, studySectionId: string): void {
        const sectionToRemove = document.getElementById('study-section-' + siteSectionId + '-' + studySectionId);
        sectionToRemove?.remove();
        const studyIds = this.studySiteMap.get(siteSectionId);
        if (studyIds) {
            const idx = studyIds.indexOf(studySectionId);
            if (idx !== -1) {
                studyIds.splice(idx, 1);
            }
        }
    }

    updateValidationVisibility(): void {
        const dialog = $('#newContactDialog');
        const firstNameInput = dialog.find('#firstName')[0] as HTMLInputElement;
        const lastNameInput = dialog.find('#lastName')[0] as HTMLInputElement;
        const emailInput = dialog.find('#email')[0] as HTMLInputElement;
        const phoneInput = dialog.find('#phoneNumber')[0] as HTMLInputElement;
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const fieldsValid =
            firstNameInput.value.trim() !== '' &&
            lastNameInput.value.trim() !== '' &&
            emailInput.value.trim() !== '' &&
            phoneInput.value.trim() !== '' &&
            regex.test(emailInput.value.trim());

        if (fieldsValid) {
            dialog.find('#validation-error').addClass('d-none');
        }

        let assignmentsValid = true;

        const siteSelects = document.querySelectorAll(`select[name$="].SiteId"]`) as NodeListOf<HTMLSelectElement>;

        if (siteSelects.length == 0) {
            assignmentsValid = false;
        }

        for (let i = 0; i < siteSelects.length; i++) {
            if (siteSelects[i].value == "-1") {
                assignmentsValid = false;
            }
        }

        const studySelects = document.querySelectorAll(`select[id^="study-"]`) as NodeListOf<HTMLSelectElement>;

        for (let i = 0; i < studySelects.length; i++) {
            if (studySelects[i].value == "-1") {
                assignmentsValid = false;
            }
        }

        const jobFunctionSelects = document.querySelectorAll(`select[id^="jobFunction-"]`) as NodeListOf<HTMLSelectElement>;

        for (let i = 0; i < jobFunctionSelects.length; i++) {
            if (jobFunctionSelects[i].value == "-1") {
                assignmentsValid = false;
            }
        }

        if (assignmentsValid) {
            dialog.find('#validation-error-assignments').addClass('d-none');
            dialog.find('#validation-error-assignments-icon').addClass('d-none');
        }

        if (
            dialog.find('#validation-error').hasClass('d-none') &&
            dialog.find('#validation-error-assignments').hasClass('d-none')
        ) {
            dialog.find('#validation-errors').addClass('d-none');
        }
    }
    

    saveForm(): void {
        const validationError = document.getElementById('validation-error');
        const dialog = $('#newContactDialog');

        if (this.validateForm()) {
            dialog.removeClass('ctms-invalid-form');
            validationError.classList.add('d-none');

            $('#newContactDialog .ctms-button-save').prop('disabled', true);
            $('#contactSaveSpinner').show();
            $.ajax({
                url: '/secure/ctms/contacts/contacts?handler=Save',
                type: 'POST',
                data: $('#newContactDialog .ctms-field-submit').serialize(),
                headers: {
                    'RequestVerificationToken': $('input[name="__RequestVerificationToken"]').val() as string
                },
                success: (response) => {
                    this.successCallback(response);
                },
                complete: () => {
                    $('#newContactDialog .ctms-button-save').prop('disabled', false);
                    $('#contactSaveSpinner').hide();
                }
            });

            $('#newContactDialog').modal('hide');
        }
        else {
            dialog.addClass('ctms-invalid-form');
            dialog.find('#validation-errors').removeClass('d-none');
        }
        
    }

    validateForm(): boolean {
        let isValid = true;
        const dialog = $('#newContactDialog');
        dialog.find('#validation-error-assignments').addClass('d-none');

        const firstNameInput = dialog.find('#firstName')[0] as HTMLInputElement;
        const lastNameInput = dialog.find('#lastName')[0] as HTMLInputElement;
        const emailInput = dialog.find('#email')[0] as HTMLInputElement;
        const phoneInput = dialog.find('#phoneNumber')[0] as HTMLInputElement;

        if (firstNameInput.value == '' || lastNameInput.value == '' || emailInput.value == '' || phoneInput.value == '') {
            isValid = false;
        }

        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailInput.value && !regex.test(emailInput.value.trim())) {
            isValid = false;
        }

        const fieldsValid = isValid;

        if (!fieldsValid) {
            dialog.find('#validation-error').removeClass('d-none');
        } else {
            dialog.find('#validation-error').addClass('d-none');
        }
        let assignmentsValid = true;

        const siteSelects = document.querySelectorAll(`select[name$="].SiteId"]`);

        if (siteSelects.length == 0) {
            assignmentsValid = false;
        }

        for (let i = 0; i < siteSelects.length; i++) {
            const siteSelect = siteSelects[i] as HTMLSelectElement;
            if (siteSelect.value == "-1") {
                assignmentsValid = false;
            }
        }

        const studySelects = document.querySelectorAll(`select[id^="study-"]`) as NodeListOf<HTMLSelectElement>;
        for (let i = 0; i < studySelects.length; i++) {
            if (studySelects[i].value == "-1") {
                assignmentsValid = false;
            }
        }

        const jobFunctionSelects = document.querySelectorAll(`select[id^="jobFunction-"]`) as NodeListOf<HTMLSelectElement>;
        for (let i = 0; i < jobFunctionSelects.length; i++) {
            if (jobFunctionSelects[i].value == "-1") {
                assignmentsValid = false;
            }
        }

        if (!assignmentsValid) {
            dialog.find('#validation-errors').removeClass('d-none');
            dialog.find('#validation-error-assignments').removeClass('d-none');
            dialog.find('#validation-error-assignments-icon').removeClass('d-none');
            isValid = false;
        }
        else {
            dialog.find('#validation-error-assignments').addClass('d-none');
            dialog.find('#validation-error-assignments-icon').addClass('d-none');
        }


        return isValid;
    }

    populateReadonlyModal(c: any): void {
        this.contact = plainToClass(ContactListingFormObject, <ContactListingFormObject>c);
        this.contact.initialize();

        // Set readonly fields
        const setText = (id: string, value: string | number | null | undefined) => {
            const el = document.getElementById(id);
            if (el) el.textContent = String(value ?? '');
        };
        setText('firstNameReadonly', this.contact.FirstName);
        setText('lastNameReadonly', this.contact.LastName);
        setText('prefixReadonly', !this.contact.Prefix || this.contact.Prefix === '-1' ? 'Select an option' : this.contact.Prefix);
        setText('emailReadonly', this.contact.Email);
        setText('phoneNumberReadonly', this.contact.PhoneNumber);
        setText('titleReadonly', this.contact.Title);
        setText('notesReadonly', this.contact.Notes);
        setText('idReadonly', this.contact.Id);

        // Render sites/studies/roles in readonly format
        const siteContainer = document.getElementById('site-container-readonly');
        if (siteContainer) {
            siteContainer.innerHTML = '';
            if (Array.isArray(this.contact.Sites) && this.contact.Sites.length > 0) {
                this.contact.Sites.forEach((site, siteIdx) => {
                    // Lookup site entity
                    const siteEntity = this.sites.find(s => s.Id === site.SiteId);
                    const siteName = siteEntity ? siteEntity.SiteName : '';
                    const studies = siteEntity ? siteEntity.CTMSStudies : [];

                    // Site header
                    const siteDiv = document.createElement('div');
                    siteDiv.className = 'ctms-section-content-wrapper mb-2';
                    siteDiv.innerHTML = `
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group ctms-form-group">
                                    <label>Site</label>
                                    <div class="ctms-form-text">${siteName}</div>
                                </div>
                            </div>
                        </div>
                    `;
                    // Studies/roles for this site
                    if (Array.isArray(site.StudyIds) && site.StudyIds.length > 0) {
                        for (let i = 0; i < site.StudyIds.length; i++) {
                            // Lookup study name
                            const studyId = site.StudyIds[i];
                            const studyObj = studies ? studies.find(study => study.Id === studyId) : null;
                            const studyName = studyObj ? studyObj.Name : '';
                            // Lookup job function name
                            const jobFunctionId = site.JobFunctionIds[i];
                            const jobFunctionObj = this.jobFunctions.find(jf => jf.Id === jobFunctionId);
                            const jobFunctionName = jobFunctionObj ? jobFunctionObj.Name : '';

                            // Primary/Receive All
                            const isPrimary = site.IsPrimaryContacts && site.IsPrimaryContacts[i] ? 'Yes' : 'No';
                            const isReceivingAll = site.IsReceivingAllCommunications && site.IsReceivingAllCommunications[i] ? 'Yes' : 'No';

                            // MI Number (only show for PI role)
                            const miNumber = site.MiNumbers && site.MiNumbers[i] ? site.MiNumbers[i] : '';
                            const isPI = jobFunctionName === 'PI';

                            const studyRoleText =
                                isPI && miNumber
                                    ? `${studyName} (${jobFunctionName}: ${miNumber})`
                                    : `${studyName} (${jobFunctionName})`;

                            const studyDiv = document.createElement('div');
                            studyDiv.className = 'row ml-3';
                            studyDiv.innerHTML = `
                                <div class="col-4">
                                    <div class="form-group ctms-form-group">
                                        <label>Study (Role)</label>
                                        <div class="ctms-form-text">${studyRoleText}</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group ctms-form-group">
                                        <label>Primary Contact</label>
                                        <div class="ctms-form-text">${isPrimary}</div>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="form-group ctms-form-group">
                                        <label>Receive All Communications</label>
                                        <div class="ctms-form-text">${isReceivingAll}</div>
                                    </div>
                                </div>
                            `;
                            siteDiv.appendChild(studyDiv);
                        }
                    }
                    siteContainer.appendChild(siteDiv);
                });
            } else {
                // No sites
                siteContainer.innerHTML = '<div class="text-muted">No site assignments.</div>';
            }
        }
    }

}

export class SiteSection extends HTMLElement {
    siteSectionId: string;


    initialize(): void {

    }

    connectedCallback(): void {
        this.innerHTML =
            `<div class="ctms-section-content-wrapper" id="site-section-${this.siteSectionId}">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group ctms-form-group">
                                <label for="site">Site</label>
                                <select class="form-control ctms-field-submit" name="SiteStudyContainers[${this.siteSectionId}].SiteId" id="site-${this.siteSectionId}"></select>
                            </div>
                        </div>
                        <button type="button" class="ctms-remove-button ctms-button" id="remove-button-${this.siteSectionId}-site"><i class="fa-solid fa-xmark"></i></button>
                    </div>
                    <div id="study-container-${this.siteSectionId}">

                    </div>
                    <div class="row ml-3">
                        <div class="col-4">
                            <button type="button" class="ctms-button ctms-dialog-button" id="add-study-${this.siteSectionId}">+ Add Study</button>
                        </div>
                    </div>
                </div>`
    }
}

export class StudySection extends HTMLElement {
    studySectionId: string;
    siteSectionId: string;


    initialize(): void {

    }

    connectedCallback(): void {
        this.innerHTML =
            `<div class="ctms-section-content-wrapper" id="study-section-${this.siteSectionId}-${this.studySectionId}">
        <div class="row ml-3" id="study-section-${this.siteSectionId}-${this.studySectionId}">
            <div class="col-4" id="studyColumn-${this.siteSectionId}-${this.studySectionId}">
                <div class="form-group ctms-form-group">
                    <label for="study-${this.siteSectionId}-${this.studySectionId}">Study</label>
                    <select class="form-control ctms-field-submit"
                            name="SiteStudyContainers[${this.siteSectionId}].StudyId[${this.studySectionId}]"
                            id="study-${this.siteSectionId}-${this.studySectionId}">
                    </select>
                </div>
            </div>

            <div class="col-4" id="roleColumn-${this.siteSectionId}-${this.studySectionId}">
                <div class="row">
                    <div class="col-12" id="jobFunctionContainer-${this.siteSectionId}-${this.studySectionId}">
                        <div class="form-group ctms-form-group">
                            <label for="jobFunction-${this.siteSectionId}-${this.studySectionId}">Role</label>
                            <select class="form-control ctms-field-submit"
                                    name="SiteStudyContainers[${this.siteSectionId}].JobFunctionId[${this.studySectionId}]"
                                    id="jobFunction-${this.siteSectionId}-${this.studySectionId}">
                            </select>
                        </div>
                    </div>

                    <div class="col-6" id="miNumberColumn-${this.siteSectionId}-${this.studySectionId}" style="display:none;">
                        <div class="form-group ctms-form-group" id="miNumberContainer-${this.siteSectionId}-${this.studySectionId}">
                            <label for="miNumber-${this.siteSectionId}-${this.studySectionId}">
                                MI Number
                                <i class="ctms-icon-history ctms-audit-icon"
                                   data-entity-type="ContactSiteStudy"
                                   data-entity-id=""
                                   data-audit-field="MiNumber"
                                   data-audit-label="MI Number"></i>
                            </label>

                            <input class="form-control ctms-field-submit"
                                   type="text"
                                   name="SiteStudyContainers[${this.siteSectionId}].MiNumber[${this.studySectionId}]"
                                   id="miNumber-${this.siteSectionId}-${this.studySectionId}">
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-2" id="checkboxColumn-${this.siteSectionId}-${this.studySectionId}">
                <div class="form-check ctms-form-check">
                    <input class="form-check-input ctms-field-submit"
                           type="checkbox"
                           value="true"
                           name="SiteStudyContainers[${this.siteSectionId}].IsPrimaryContact[${this.studySectionId}]"
                           id="isPrimaryContact-${this.siteSectionId}-${this.studySectionId}">
                    <input type="hidden"
                           class="ctms-field-submit"
                           name="SiteStudyContainers[${this.siteSectionId}].IsPrimaryContact[${this.studySectionId}]"
                           value="false" />
                    <label class="form-check-label"
                           for="isPrimaryContact-${this.siteSectionId}-${this.studySectionId}">
                        Primary Contact
                    </label>
                </div>

                <div class="form-check ctms-form-check">
                    <input class="form-check-input ctms-field-submit"
                           type="checkbox"
                           value="true"
                           name="SiteStudyContainers[${this.siteSectionId}].IsReceivingAllCommunications[${this.studySectionId}]"
                           id="isReceivingAllCommunications-${this.siteSectionId}-${this.studySectionId}">
                    <input type="hidden"
                           class="ctms-field-submit"
                           name="SiteStudyContainers[${this.siteSectionId}].IsReceivingAllCommunications[${this.studySectionId}]"
                           value="false" />
                    <label class="form-check-label"
                           for="isReceivingAllCommunications-${this.siteSectionId}-${this.studySectionId}">
                        Receive All Communications
                    </label>
                </div>
            </div>

            <div class="col-2">
                <button type="button"
                        class="ctms-remove-button ctms-button"
                        id="study-remove-button-${this.siteSectionId}-${this.studySectionId}">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
        </div>
    </div>`;
    }
}